import { IOption } from '@/interfaces';

import {
  FaceIdRegistrationStatus,
  ProfileStatus,
  ProfileType,
} from '@/features/face-id-profiles/enums';
import {
  getFaceIdRegistrationStatusLabel,
  getProfileStatusLabel,
  getProfileTypeLabel,
} from '@/features/face-id-profiles/utils';

export const PROFILE_TYPE_OPTIONS: IOption[] = [
  {
    label: getProfileTypeLabel(ProfileType.Employee),
    value: ProfileType.Employee.toString(),
  },
  {
    label: getProfileTypeLabel(ProfileType.Guest),
    value: ProfileType.Guest.toString(),
  },
];

export const PROFILE_STATUS_OPTIONS: IOption[] = [
  {
    label: getProfileStatusLabel(ProfileStatus.Active),
    value: ProfileStatus.Active.toString(),
  },
  {
    label: getProfileStatusLabel(ProfileStatus.Inactive),
    value: ProfileStatus.Inactive.toString(),
  },
];

export const FACE_ID_REGISTRATION_STATUS_OPTIONS: IOption[] = [
  {
    label: getFaceIdRegistrationStatusLabel(FaceIdRegistrationStatus.Pending),
    value: FaceIdRegistrationStatus.Pending.toString(),
  },
  {
    label: getFaceIdRegistrationStatusLabel(FaceIdRegistrationStatus.Registered),
    value: FaceIdRegistrationStatus.Registered.toString(),
  },
];
